<template>
  <div id="pause-serve">
    <pause-serve-header></pause-serve-header>

    <div class="pc-container">
      <div class="content">
        <p class="zh-text">{{ pauseServeInfoZh }}</p>
        <p class="en-text">{{ pauseServeInfoEn }}</p>
      </div>
    </div>

    <div class="phone-container">
      <p>{{ phone.sorryNoticeZh }}</p>
      <p class="en-text higher-bottom"><span>{{ phone.sorryNoticeEn }}</span></p>
      <p>{{ phone.pauseServeZh }}</p>
      <p class="en-text">{{ phone.pauseServeEn }}</p>
    </div>

  </div>
</template>

<script>
  import PauseServeHeader from '../../components/plexHeader/pauseServerHeader.vue'

  export default {
    name: 'pause-serve',
    components: {PauseServeHeader},
    data: function () {
      return {
        pauseServeInfoZh: '抱歉，根据您当前所在国家的法律法规，暂停提供相关服务',
        pauseServeInfoEn: 'Sorry, the service is suspended according to the laws and regulations of your country.',
        phone: {
          'sorryNoticeZh': '抱歉，根据您当前所在国家的法律法规，',
          'pauseServeZh': '暂停提供相关服务',
          'sorryNoticeEn': 'Sorry, the service is suspended according to the laws',
          'pauseServeEn': 'and regulations of your country.'
        }
      }
    },
    computed: {
      pauseServeInfo() {
        return this.$store.state.pauseServeInfo
      }
    },
    mounted() {
      if (!this.pauseServeInfo) {
        this.$router.replace('/')
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .pc-container, .phone-container {
    display: none;
  }

  @media screen and (max-width: 767px) {
    #pause-serve {
      display: table;
      table-layout: fixed;
      height: 100vh;
      width: 100%;
    }

    div.phone-container {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      width: 100%;
    }

    div.phone-container {
      height: calc(100vh - .6rem);
      display: table-cell;
      padding: .32rem;
      p {
        font-size: .16rem;
        color: #333333;
        letter-spacing: 1.12px;
        line-height: .16rem;
      }
      p:not(:last-child) {
        padding-bottom: .1rem;
      }
      p.en-text {
        font-size: .12rem;
        color: #999999;
        letter-spacing: .006rem;
        line-height: .16rem;
        &.higher-bottom {
          padding-bottom: .3rem;
        }
      }
    }
  }

  @media screen and (max-width: 374px) {
    div.phone-container p span {
      display: block;
      font-size: .12rem;
      transform: scale(0.85);
      *font-size: 10px;
      white-space: nowrap;
      transform-origin: center center;
    }
  }
  @media screen and (max-width: 320px) {
    div.phone-container p span {
      transform-origin: left center;
    }
  }

  @media screen and (min-width: 768px) {
    div.pc-container {
      display: table;
      table-layout: fixed;
      height: calc(100vh - 1rem);
      padding: .2rem;
      width: 100%;
    }
    div.content {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      width: 100%;
      p {
        font-size: .2rem;
        color: #999999;
        letter-spacing: 1px;
      }
      p.zh-text {
        margin-bottom: .2rem;
        color: #333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?26ffbd07